import { Flex, Spinner, Box } from "@chakra-ui/react"
import { Outlet, createFileRoute, redirect, useLocation } from "@tanstack/react-router"

import Sidebar from "../components/Common/Sidebar"
import UserMenu from "../components/Common/UserMenu"
import useAuth, { isLoggedIn } from "../hooks/useAuth"

import LanguageSelector from "../components/Language/LanguageSelector";
import ThemeToggleButton from "../components/Common/ThemeToggleButton";
import ConsentCheck from "../components/Modals/Consent/ConsentCheck"

import NotificationDrawer from "../components/Notification/NotificationDrawer.tsx";
import QRScanButton from "../components/QR/QRScanButton";
import MyQrButton from "../components/Common/MyQrButton";
import LicenseModeGuard from "../components/License/LicenseModeGuard";
import LicenseRuntimeBanner from "../components/License/LicenseRuntimeBanner";
import useLicenseSummary from "../hooks/useLicenseSummary";


export const Route = createFileRoute("/_layout")({
  component: Layout,
  beforeLoad: async () => {
    if (!isLoggedIn()) {
      throw redirect({
        to: "/login",
      })
    }
  },
})

function Layout() {
    const { isLoading, user } = useAuth()
    const location = useLocation()
    const licenseSummaryQuery = useLicenseSummary()
    const canScanQR = !!(user?.isSuperAdmin || user?.isAdmin)
    const summary = licenseSummaryQuery.data

    return (
        <Flex w="100vw" h="100dvh" overflow="hidden">
            <Sidebar />

            <Flex
                direction="column"
                flex="1 1 auto"
                minH={0}            // дозволяє дочці скролитись
            >
                {/* Header */}
                <Flex
                    as="header"
                    align="center"
                    justify="flex-end"
                    borderRadius={12}
                    w="full"
                    px={4}
                    py={3}
                    gap={3}
                    flexShrink={0}    // хедер фіксованої висоти
                >
                    <LanguageSelector />
                    <ThemeToggleButton />
                    {canScanQR && <QRScanButton />}
                    <MyQrButton />
                    <NotificationDrawer />
                    <UserMenu />
                </Flex>

                {/* Контент: єдина вертикальна скрол-зона */}
                <Box
                    as="main"
                    flex="1 1 auto"
                    minH={0}
                    overflowY="auto"
                    overflowX="hidden"
                    px={4}
                    pb={4}
                >
                    {isLoading ? (
                        <Flex justify="center" align="center" minH="200px">
                            <Spinner size="xl" color="ui.main" />
                        </Flex>
                    ) : (
                        <ConsentCheck>
                            <>
                                <LicenseRuntimeBanner summary={summary} />
                                <LicenseModeGuard summary={summary} user={user} pathname={location.pathname}>
                                    <Outlet />
                                </LicenseModeGuard>
                            </>
                        </ConsentCheck>
                    )}
                </Box>
            </Flex>
        </Flex>
    )
}

